/**
 * Legacy account_availabilities.start/end are stored as seconds from midnight.
 * Some newer rows may be stored as minutes. Normalize to minutes-from-midnight.
 */
export function dbAvailabilityToMinutes(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return 0;
  if (n <= 1440) return n;
  // Seconds: divisible by 60 and converts to <= 48h in minutes.
  if (n % 60 === 0 && n / 60 <= 2880) return n / 60;
  return n;
}

/** Persist as legacy seconds-from-midnight (may exceed 86400 for next-day end). */
export function availabilityMinutesToDb(minutes) {
  const n = Number(minutes);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.round(n * 60);
}

export function minutesToTimeInputLabel(minutes) {
  const normalized = ((Number(minutes) % 1440) + 1440) % 1440;
  const h = Math.floor(normalized / 60);
  const m = normalized % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function parseTimeInputToMinutes(timeStr) {
  if (!timeStr) return 0;
  if (timeStr === "Anytime") return 0;
  if (timeStr === "Midnight") return 1439;

  if (/^\d{1,2}:\d{2}$/.test(timeStr)) {
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  }

  const match = String(timeStr).match(/(\d+):(\d+)\s*(AM|PM)/i);
  if (!match) return 0;
  let hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const ampm = match[3].toUpperCase();
  if (ampm === "PM" && hours !== 12) hours += 12;
  if (ampm === "AM" && hours === 12) hours = 0;
  return hours * 60 + minutes;
}

export function buildAvailabilitySlotFromDb(startRaw, endRaw) {
  const startMin = dbAvailabilityToMinutes(startRaw);
  const endMin = dbAvailabilityToMinutes(endRaw);
  const spansNextDay = endMin >= 1440;
  return {
    start: minutesToTimeInputLabel(startMin),
    end: minutesToTimeInputLabel(spansNextDay ? endMin % 1440 : endMin),
    nextDay: spansNextDay,
  };
}

export function buildDbPatternFromSlot(day, timeSlot) {
  const startMin = parseTimeInputToMinutes(timeSlot.start);
  let endMin = parseTimeInputToMinutes(timeSlot.end);
  if (timeSlot.nextDay || endMin <= startMin) {
    endMin += 1440;
  }
  return {
    day,
    start: availabilityMinutesToDb(startMin),
    end: availabilityMinutesToDb(endMin),
  };
}
